'use client'

import type { AccordionModalProps } from '@pearlconvert/ui/components/accordion/accordion.types'

import React, { useEffect } from 'react'

import {
  SlideInBody,
  SlideInFooter,
} from '@pearlconvert/ui/components/slide-in'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

const AccordionModal: React.FC<AccordionModalProps> = ({
  children,
  title,
  id,
  footerContent,
  onClose,
  hash,
}) => {
  const { addModal } = useModals()

  useEffect(() => {
    addModal({
      key: id,
      hash,
      Component: (
        <>
          <SlideInBody>{children}</SlideInBody>
          {footerContent && <SlideInFooter>{footerContent}</SlideInFooter>}
        </>
      ),
      props: { title, onClose, modalId: id },
    })
  }, [addModal, children, footerContent, hash, id, onClose, title])

  return null
}

export default AccordionModal
